import guidedSearch from '../guided-search';

/**
 * Checkbox component
 * @param {GuidedSearchData} props
 */
const fetchGuidedSearch = async (rootNodeId, rootNodeType, language) => {
  const guidedSearchPromise = guidedSearch.get(
    rootNodeId,
    rootNodeType,
    language,
  );
  const guidedSearchResponse = await guidedSearchPromise;
  if (guidedSearchResponse.status !== 'OK') {
    throw Error('Got unexpected response');
  }
  const { data } = guidedSearchResponse;
  return data;
};

export default fetchGuidedSearch;
